import styled from 'styled-components'

export const DesktopMenuWrapper = styled.div``
